import { SearchOutlined } from "@ant-design/icons";
import { SelectedItem } from "../model/types/ProjectSelection";
import { BlockNode } from "../model/types/ProjectTree";
import {
  BaseSelect,
  SelectOption,
} from "components/AntDesign/Select/BaseSelect";

type BlockSelectorProps = {
  blocks: BlockNode[];
  value: SelectedItem[];
  disabled?: boolean;
  onChange: (value: SelectedItem[]) => void;
};

export function BlockSelector({
  blocks,
  value,
  disabled,
  onChange,
}: BlockSelectorProps) {
  const options: SelectOption<number>[] = blocks.map((b) => ({
    value: b.id,
    label: b.label,
  }));

  const selectedValue = value[0]?.id;

  const handleChange = (val?: number) => {
    if (val === undefined) {
      onChange([]);
      return;
    }

    const option = options.find((o) => o.value === val);

    onChange([
      {
        id: val,
        label: option?.label ?? "",
      },
    ]);
  };

  return (
    <BaseSelect<number>
      options={options}
      value={selectedValue}
      disabled={disabled}
      prefix={<SearchOutlined />}
      float={{ label: "Select block" }}
      onChange={handleChange}
    />
  );
}
